import { render, staticRenderFns } from "./receiveLimitDetail.vue?vue&type=template&id=1b740668&scoped=true&"
import script from "./receiveLimitDetail.vue?vue&type=script&lang=js&"
export * from "./receiveLimitDetail.vue?vue&type=script&lang=js&"
import style0 from "./receiveLimitDetail.vue?vue&type=style&index=0&id=1b740668&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b740668",
  null
  
)

export default component.exports